import request from "@/api/request";

//获取支付列表
export function getPayList(enm) {
  return request({
    url: `/app/payList/getPayList?card=${localStorage.getItem(
      "meCardNum"
    )}&payListType=${enm}`,
  });
}

//套餐拉起支付
export function sendSetMeal(
  mealId,
  payId,
  code,
  next,
  payType,
  speedMembership,
  speedMemberId
) {
  return request({
    url: `/app/payList/sendSetMeal?card=${localStorage.getItem(
      "meCardNum"
    )}&mealId=${mealId}&payId=${payId}&code=${code}&next=${next}&payType=${payType}&flag=${speedMembership}&speedMemberId=${speedMemberId}`,
  });
}

//js套餐拉起支付
export function sendSetMealJs(
  card,
  mealId,
  payId,
  code,
  next,
  payType,
  speedMembership,
  speedMemberId
) {
  return request({
    url: `/app/payList/sendSetMeal?card=${card}&mealId=${mealId}&payId=${payId}&code=${code}&next=${next}&payType=${payType}&flag=${speedMembership}&speedMemberId=${speedMemberId}`,
  });
}

//余额拉起支付
export function xiaoBaiYuanPay(
  mealId,
  payId,
  code,
  next,
  setMealId,
  nextType,
  flag
) {
  return request({
    url: `/app/payUserBalance/payALl?card=${localStorage.getItem(
      "meCardNum"
    )}&balance=${mealId}&payId=${payId}&code=${code}&payType=${next}&setMealId=${setMealId}&next=${nextType}&flag=${flag}`,
  });
}

//js余额拉起支付
export function xiaoBaiYuanPayJs(
  card,
  mealId,
  payId,
  code,
  next,
  setMealId,
  nextType,
  flag
) {
  return request({
    url: `/app/payUserBalance/payALl?card=${card}&balance=${mealId}&payId=${payId}&code=${code}&payType=${next}&setMealId=${setMealId}&next=${nextType}&flag=${flag}`,
  });
}

//卡余额拉起支付
export function addOrders(
  mealId,
  payId,
  code,
  next,
  speedMembership,
  speedMemberId
) {
  return request({
    url: `/app/orders/addOrders?meCardNum=${localStorage.getItem(
      "meCardNum"
    )}&setmealId=${mealId}&payPassWord=${payId}&payType=${code}&monthType=${next}&flag=${speedMembership}&speedMemberId=${speedMemberId}`,
  });
}

//代理充值余额
export function weixinPayJS(balance, payId, userId, code) {
  return request({
    url: `/app/userPay/weixinPayJS?balance=${balance}&payId=${payId}&userId=${userId}&code=${code}`,
  });
}

//优惠方案支付
export function addSeriesCouponOrder(card, payId, code, buttonSelection) {
  return request({
    url: `/app/seriesCouponOrder/addSeriesCouponOrder?card=${card}&payId=${payId}&code=${code}&buttonSelection=${buttonSelection}`,
  });
}

//获取支付类型
export function getPayTypeAll() {
  return request({
    url: `/app/payType/getPayTypeAll`,
  });
}

//邮费拉起支付
export function PayPostAge(data) {
  return request({
    url: `/app/payList/PayPostAge`,
    method: "post",
    data,
  });
}

//JS邮费拉起支付
export function PayPostAgeJs(data) {
  return request({
    url: `/app/payList/PayPostAge`,
    method: "post",
    data,
  });
}

//换卡上传信息
export function savePayPostAge(data) {
  return request({
    url: `/app/payList/savePayPostAge`,
    method: "post",
    data,
  });
}

//极速会员列表
export function speedMembership(data) {
  return request({
    url: `/app/speedMemberOrders/getByCard?card=` + data,
  });
}

//极速会员在线支付
export function paySpeedMember(payId, code, payType, val, speedMemberId) {
  return request({
    url: `/app/payList/paySpeedMember?card=${localStorage.getItem(
      "meCardNum"
    )}&payId=${payId}&code=${code}&payType=${payType}&num=${val}&speedMemberId=${speedMemberId}`,
  });
}

//极速会员在线支付
export function paySpeedMembers(
  payId,
  code,
  payType,
  val,
  speedMemberId,
  card
) {
  return request({
    url: `/app/payList/paySpeedMember?card=${card}&payId=${payId}&code=${code}&payType=${payType}&num=${val}&speedMemberId=${speedMemberId}`,
  });
}

//极速会员余额支付
export function balancePurchase(payId, val, speedMemberId) {
  return request({
    url: `/app/speedMemberOrders/balancePurchase?card=${localStorage.getItem(
      "meCardNum"
    )}&passWord=${payId}&num=${val}&speedMemberId=${speedMemberId}`,
  });
}

//升级套餐拉起支付
export function sendDifferenceSetMeal(card, mealId, payId, code, payType) {
  return request({
    url: `/app/payList/sendDifferenceSetMeal?card=${card}&mealId=${mealId}&payId=${payId}&code=${code}&payType=${payType}`,
  });
}
